
































































































import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import GenericAutocomplete from '../../../generic/forms/Autocomplete.vue';
import Icon from '../../../generic/Icon.vue';
import { GitLabGateway, GitLabProject } from 'ganttlab-gateways';
import { DisplayableError } from '../../../../helpers/DisplayableError';
import { addDisplaybleError } from '../../../../helpers';
import { Project } from 'ganttlab-entities';

@Component({
  components: {
    GenericAutocomplete,
    Icon,
  },
})
export default class ProjectViewConfigurator extends Vue {
  public search = '';
  public loading = false;
  public projects: Array<GitLabProject> | null = null;
  public project: GitLabProject | null = null;

  @Prop({ required: true }) readonly sourceGateway!: GitLabGateway;

  async searchProjects(newSearch: string) {
    this.search = newSearch;
    if (!newSearch) {
      // empty search? empty projects!
      this.projects = null;
      return;
    }
    if (this.project && newSearch === this.project.path_with_namespace) {
      // same? do nothing!
      return;
    }
    try {
      this.loading = true;
      this.projects = await this.sourceGateway.searchProjects(newSearch);
      this.loading = false;
    } catch (error) {
      this.projects = null;
      this.loading = false;
      addDisplaybleError(
        new DisplayableError(error, 'Error while searching for that'),
      );
    }
  }

  setProject(project: GitLabProject) {
    if (
      this.project &&
      this.project.path_with_namespace === project.path_with_namespace
    ) {
      // same? do nothing!
      return;
    }
    this.project = project;
    this.setConfiguration();
  }

  get configuration() {
    if (this.project) {
      return {
        project: new Project(
          this.project.name,
          this.project.path_with_namespace,
          this.project.web_url,
          this.project.description,
          this.project.avatar_url,
        ),
        tasks: {
          page: 1,
          pageSize: 50,
        },
      };
    }
    return null;
  }

  @Emit('set-configuration')
  setConfiguration() {
    const configuration = this.configuration;
    if (configuration) {
      return this.configuration;
    }
  }
}
